module.exports = __webpack_public_path__ + "img/MapImage.66bb9223.png";